import React, { useEffect, useState } from 'react';
import '../assets/css/Splash.css';
import logo from '../assets/images/Logo.svg';
import Login from './Login';
import { useSelector } from 'react-redux';

function Splash() {
	const [toLogin, setToLogin] = useState(0);

	useEffect(() => {
		setTimeout(() => setToLogin(1), 3000);
	});

	if (toLogin) {
		return <Login />;
	}

	return (
		<div className='splash-background'>
			<img src={logo} className='splash-logo' alt='logo' />
		</div>
	);
}

export default Splash;
